export default __webpack_public_path__ + "9284ae432da14885a82c40febedee824.svg";